import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';
import { ZipcodesSuggestionRoutingModule } from './zipcodes-suggestion-routing.module';
import { ZipcodesSuggestionComponent } from './zipcodes-suggestion.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { CardsModule } from '../shared/cards/cards.module';
import { AddZipcodeComponent } from './add-zipcode/add-zipcode.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ZipcodesSuggestionRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    CardsModule
  ],
  declarations: [ZipcodesSuggestionComponent, AddZipcodeComponent]
})
export class ZipcodesSuggestionModule {}
